var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`formulate-input-element formulate-input-element--${_vm.context.type} ${_vm.context.classes.element}`,attrs:{"data-type":_vm.context.type}},[_c('list-select',{attrs:{"context":_vm.context,"isLoading":_vm.isLoading,"options":_vm.context.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }